import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { CaseLogTypesService } from '../../cases/_services/cases-log-types.service';
import { CaseLogType } from '../../cases/_types/case-log-type';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-cases-log-types-list',
    templateUrl: './cases-log-types-list.component.html',
    styleUrls: ['./cases-log-types-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class CasesLogTypesListComponent {
  public casesLogTypes: CaseLogType[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private casesLogTypesService: CaseLogTypesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
        private loginService: LoginService
  ) {
    
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Categorías de eventos");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as CaseLogType);
    });
    this.allowWrite = this.loginService.hasPermission("CASES_LOGS_TYPES.WRITE")
    this.allowDelete = this.loginService.hasPermission("CASES_LOGS_TYPES.DELETE")
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.casesLogTypesService.all(params));
    this.casesLogTypes = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(caseState: CaseLogType) {
    this.router.navigate(['casesLogTypes/' + (caseState && Object.keys(caseState).length > 0 ? caseState.id : 0)]);
  }

  delete(caseState: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la categoría?",
        header: "Eliminar categoría",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesLogTypesService.delete(caseState.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Categoría eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }
}
